import React, { Component, useState, useRef, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import '../99_untils/i18n/';
import {
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

// import Swiper JS
// import { Swiper, SwiperSlide } from 'swiper/react';
// import required modules
// import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// Import Swiper styles
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

import Marquee from "react-fast-marquee";

import apiURLs from '../99_untils/apiURLs';

import './IGPosts.css';

export default function IGPosts(props) {
  // console.log("IGPosts constructor started ")
  const isMountedRef = useRef();
  // const [swiperRef, setSwiperRef] = useState(null);
  const { t } = useTranslation();
      const { i18n } = useTranslation();
      let curLang = i18n.language;

  const [igPostsData, setIgPostsData] = useState(null);
  


  useEffect(() => {

    isMountedRef.current = true;

    const fetchData = async () => {
      try {
        const response = await fetch(apiURLs.getIGPostsDataURL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(window.authTokenData ? { 'Authorization': `Bearer ${window.authTokenData}` } : {})
          }
        });
        // const response = await fetch('https://api.once.dev2.dash-hk.com/instagram/posts');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        if (isMountedRef.current) { // Only update state if the component is still mounted

          setIgPostsData(result);
          // console.log(result)

        }
      } catch (error) {
        //   setError(error);
        // console.log('fetchData error')
      } finally {
        // console.log('fetchData loading finished ')
        //   setLoading(false);
      }
    };

    fetchData();
    

    return () => {
      isMountedRef.current = false;
      
      // console.log("IG posts unmount")

    };
  }, []);





  return (
    <div className="IGPost-intro-wrap">

      <Container className="IGPost-intro-content-wrap">
        <Row className=''>
          <Col>
            <h5 className={`text-uppercase color-text-pink margin-bot-10 home-title ${curLang === 'zh-HK' ? 'zh' : ''}`}>
              {t('IGPostIntroTitle')}
              </h5>
            <p className='color-text-pink margin-bot-30'>{t('IGPostIntroContent')}</p>
          </Col>
        </Row>
      </Container>
      <Container className="IGPost-intro-slide-wrap">
        <Row className=''>
          <Col
            md={{
              offset: 3,
              size: 6
            }}
          >
            {igPostsData && igPostsData.length > 0 ?
/*
            <Swiper
              onSwiper={setSwiperRef}
              slidesPerView={3}
              centeredSlides={true}
              spaceBetween={10}
              // pagination={{
              //   type: 'fraction',
              // }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              // loop={true}
              // navigation={true}
              // modules={[Pagination, Navigation]}
              modules={[Autoplay, Navigation]}
              onSlideChange={() => {
                //   console.log("swiperRef idolNameFocus = " + idolNameFocus)
              }}
              // onClick={() => {
              //   if (swiperRef) {
              //     console.log("onClick + realIndex = " +swiperRef.realIndex)
              //     // setIdolNameFocus(swiperRef.realIndex)
              //   }
              // }}
              className="igPostSwiper"
            >
              {Object.entries(igPostsData).map(([postId, postData], index) => (
                <SwiperSlide key={index} virtualIndex={index}>
                  <img className="IGPost-intro-slide-imgs" 
                  src={postData.mediaUrl} alt={postData.caption} loading="lazy" />
                </SwiperSlide>
              ))}
            </Swiper>
            */
          <Marquee>
            {Object.entries(igPostsData).map(([postId, postData], index) => (
                
                  <img key={postId} className="IGPost-intro-slide-imgs" 
                  src={postData.mediaUrl} alt={postData.caption} loading="lazy" />
                
              ))}
             
            </Marquee>
            : <h5 className="IGPost-intro-slide-loading">Loading...</h5>}
          </Col>
        </Row>
      </Container>
    </div>
  );
  // }
}

